module.exports = __webpack_public_path__ + "static/media/plano_maipu.a6a94c67.png";